<ng-container *ngIf='data.utilisateur'>
  <p>Modification d'un utilisateur</p>

  <form [formGroup]="formUser" (ngSubmit)="onSubmit()">
  
      <mat-form-field>
          <input matInput placeholder="Login" formControlName="login" >
        </mat-form-field>
  
      <mat-form-field>
          <input matInput placeholder="Nom" formControlName="nom" >
        </mat-form-field>
  
        <mat-form-field>
          <input matInput placeholder="Prénom" formControlName="prenom" >
        </mat-form-field>
  
        <mat-form-field>
          <input matInput placeholder="Password" formControlName="pwd" >
        </mat-form-field>
  
        <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button> <br>

       <div class="warning">
        <p> Attention : si vous saisissez un password, celui-ci remplacera l'ancien.</p>
        </div> 
  
  
  </form>
    
</ng-container>
